import React, { useState, useEffect } from 'react';
import moment from 'moment';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { paramConverter } from 'modules/common';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

import TopMediaStatisticsGraph from './Month6StatisticsGraph';

const Statistics = ({ location }) => {
  let initParams = {
    sDate: moment().add(-1, 'year').format('YYYYMMDD'),
    eDate: moment().add(-1, 'day').format('YYYYMMDD'),
    kakaoFlagCode: 'all',
    openrtbFlagCode: 'all',
  };

  const { adverId, mediaScriptNo, advrtsTpCode } = queryString.parse(
    location.search
  );
  const { t } = useTranslation();

  if (typeof adverId !== 'undefined') initParams.adverId = adverId;

  if (typeof mediaScriptNo !== 'undefined')
    initParams.mediaScriptNo = mediaScriptNo;

  if (typeof advrtsTpCode !== 'undefined')
    initParams.advrtsTpCode = advrtsTpCode;

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const filterRtb = {
    list: [
      { label: '포함', value: 'all' },
      { label: '제외', value: '01' },
    ],
    kakaoFlagCode: '',
    openrtbFlagCode: '',
  };

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  /**
   * 필터창 닫는 핸들링 받아오는 함수
   */
  //   getOnClose = (handleClose) => {
  //     this.closePopover = handleClose;
  //   };
  switch (params.kakaoFlagCode) {
    case '01':
      filterRtb.kakaoFlagCode = '제외';
      break;
    default:
      filterRtb.kakaoFlagCode = '포함';
      break;
  }
  switch (params.openrtbFlagCode) {
    case '01':
      filterRtb.openrtbFlagCode = '제외';
      break;
    default:
      filterRtb.openrtbFlagCode = '포함';
      break;
  }

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
        />
        <FilterCollection
          label={t('kakao RTB 포함')}
          name="kakaoFlagCode"
          params={params}
          value={params.kakaoFlagCode}
          type="radio"
          list={filterRtb.list}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
        />

        <FilterCollection
          label={t('OPEN RTB 포함')}
          name="openrtbFlagCode"
          params={params}
          value={params.openrtbFlagCode}
          type="radio"
          list={filterRtb.list}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
        />
      </NewFilterWrap>

      <>
        <TopMediaStatisticsGraph params={{ ...paramConverter(params) }} />
      </>
    </>
  );
};

export default withRouter(Statistics);
